const contactProfile = {
    contactProfile: {
      pageTitle: '교신 프로필',
      pageDescription: '등록된 교신 프로필을 확인하고 관리하세요',
      button: {
        delete: '삭제',
        add: '교신 프로필 등록'
      }
    }
  };
export default contactProfile;